/**
 * Ohne Rotkohl - Upgrade-Fenster nach "In den Warenkorb"
 * ------------------------------------------------------
 * Hoert auf das Theme-Event "cart:update", das product-form.js nach einem
 * erfolgreichen Hinzufuegen feuert. Wurde ein Poster (Material "Poster")
 * hinzugefuegt, oeffnet sich das Fenster aus snippets/or-upsell-modal.liquid
 * und bietet dasselbe Motiv als Leinwand (zuerst) oder mit Rahmen an.
 *
 * Ein Upgrade tauscht die Poster-Variante im Warenkorb gegen die gewaehlte
 * Variante (gleiche Menge) ueber /cart/update.js und feuert danach selbst ein
 * "cart:update", damit Warenkorb-Drawer, Zaehler und Versandbalken des
 * Themes sich wie gewohnt aktualisieren.
 *
 * Ohne JavaScript passiert nichts: der Warenkorb funktioniert wie bisher.
 */
(function () {
  'use strict';

  var DIN = ['A4', 'A3', 'A2', 'A1', 'A0'];
  var CANVAS = ['20x30', '30x45', '50x70', '70x100', '80x120'];

  function list(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function norm(s) {
    return String(s || '')
      .replace(/\s+/g, '')
      .replace(/×/g, 'x')
      .toUpperCase();
  }

  function dinIndex(format) {
    var f = norm(format);
    for (var i = 0; i < DIN.length; i++) {
      if (f.indexOf(DIN[i]) === 0) return i;
    }
    return -1;
  }

  function canvasIndex(format) {
    var f = norm(format);
    for (var i = 0; i < CANVAS.length; i++) {
      if (f.indexOf(CANVAS[i].toUpperCase()) === 0) return i;
    }
    return -1;
  }

  function isPoster(v) {
    return norm(v.material) === 'POSTER';
  }

  function isCanvas(v) {
    return norm(v.material) === 'LEINWAND';
  }

  function isFrame(v) {
    return norm(v.material).indexOf('POSTERMITRAHMEN') === 0;
  }

  function frameColor(v) {
    var m = String(v.material || '');
    var match = m.match(/\(([^)]+)\)/);
    return match ? match[1].trim() : m.replace(/^Poster mit Rahmen/i, '').trim();
  }

  function frameColorKey(v) {
    return norm(frameColor(v));
  }

  /* ---------- Geld ---------- */

  function thousands(str, sep) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function makeMoney(format) {
    var fmt = String(format || '€{{amount_with_comma_separator}}');
    return function (cents) {
      var n = Math.abs(Number(cents) || 0) / 100;
      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount_no_decimals':
            return thousands(String(Math.round(n)), ',');
          case 'amount_with_comma_separator':
            return thousands(n.toFixed(2), '.').replace(/\.(\d\d)$/, ',$1');
          case 'amount_no_decimals_with_comma_separator':
            return thousands(String(Math.round(n)), '.');
          case 'amount_with_apostrophe_separator':
            return thousands(n.toFixed(2), "'");
          case 'amount_with_space_separator':
            return thousands(n.toFixed(2), ' ').replace(/\.(\d\d)$/, ',$1');
          case 'amount_no_decimals_with_space_separator':
            return thousands(String(Math.round(n)), ' ');
          default:
            return thousands(n.toFixed(2), ',');
        }
      });
      return out.replace(/<[^>]*>/g, '').trim();
    };
  }

  /* ---------- Warenkorb ---------- */

  function cartSectionIds() {
    var ids = [];
    list(document.querySelectorAll('cart-items-component')).forEach(function (el) {
      var id = el.dataset ? el.dataset.sectionId : null;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      cart: r.cart_url || root + 'cart',
      update: (r.cart_update_url || root + 'cart/update') + '.js'
    };
  }

  function fetchCart() {
    return fetch(routes().cart + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function quantityOf(cart, variantId) {
    var q = 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) q += Number(item.quantity) || 0;
    });
    return q;
  }

  function swapInCart(fromId, toId, qty) {
    return fetchCart().then(function (cart) {
      var have = quantityOf(cart, fromId);
      var move = Math.min(qty, have);
      if (move <= 0) move = qty;

      var updates = {};
      updates[String(fromId)] = Math.max(0, have - move);
      updates[String(toId)] = quantityOf(cart, toId) + move;

      var body = {
        updates: updates,
        sections: cartSectionIds().join(','),
        sections_url: window.location.pathname
      };

      return fetch(routes().update, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw new Error(json.message || json.description || 'cart update failed');
          return json;
        });
      });
    });
  }

  function announceCart(cart) {
    // Gleiches Format wie CartUpdateEvent in assets/events.js. Quelle ist NICHT
    // "product-form-component", damit der Zaehler im Header den absoluten
    // Stand uebernimmt statt zu addieren.
    var event = new Event('cart:update', { bubbles: true });
    event.detail = {
      resource: cart,
      sourceId: 'or-upsell-modal',
      data: {
        source: 'or-upsell-modal',
        itemCount: Number(cart.item_count) || 0,
        sections: cart.sections || undefined
      }
    };
    document.dispatchEvent(event);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  /* ---------- Fenster ---------- */

  function init(root) {
    if (root.dataset.orUpInit === '1') return;

    var dataEl = root.querySelector('[data-or-upsell-data]');
    var dialog = root.querySelector('[data-or-up-dialog]');
    if (!dataEl || !dialog || typeof dialog.showModal !== 'function') return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent || 'null');
    } catch (error) {
      return;
    }
    if (!data || !data.variants || !data.variants.length) return;

    root.dataset.orUpInit = '1';

    var money = makeMoney(data.moneyFormat);
    var byId = {};
    data.variants.forEach(function (v) {
      byId[String(v.id)] = v;
    });

    var ui = {
      current: root.querySelector('[data-or-up-current]'),
      error: root.querySelector('[data-or-up-error]'),
      decline: root.querySelector('[data-or-up-decline]'),
      close: root.querySelector('[data-or-up-close]'),
      cards: {
        canvas: root.querySelector('[data-or-up-card="canvas"]'),
        frame: root.querySelector('[data-or-up-card="frame"]')
      },
      colors: root.querySelector('[data-or-up-colors]')
    };

    var state = { from: null, qty: 1, canvas: null, frames: [], frame: null, busy: false };

    function card(kind, sel) {
      return ui.cards[kind] ? ui.cards[kind].querySelector(sel) : null;
    }

    function findCanvas(from) {
      var i = dinIndex(from.format);
      if (i < 0) return null;
      var hit = null;
      data.variants.forEach(function (v) {
        if (!hit && isCanvas(v) && v.available && canvasIndex(v.format) === i) hit = v;
      });
      return hit;
    }

    function findFrames(from) {
      var key = norm(from.format);
      return data.variants.filter(function (v) {
        return isFrame(v) && v.available && norm(v.format) === key;
      });
    }

    function setPhoto(kind, variant) {
      var visual = card(kind, '[data-or-up-visual]');
      if (!visual) return;
      var img = visual.querySelector('.or-up__photo');
      var picto = visual.querySelector('.or-up__picto');
      if (variant && variant.image) {
        img.src = variant.image;
        img.hidden = false;
        if (picto) picto.hidden = true;
        visual.classList.add('or-up__visual--photo');
      } else {
        img.removeAttribute('src');
        img.hidden = true;
        if (picto) picto.hidden = false;
        visual.classList.remove('or-up__visual--photo');
      }
    }

    function setPrices(kind, target) {
      var diff = card(kind, '[data-or-up-diff]');
      var total = card(kind, '[data-or-up-total]');
      var short = card(kind, '[data-or-up-short]');
      if (!target) return;
      var delta = Number(target.price) - Number(state.from.price);
      var sign = delta >= 0 ? '+' : '-';
      var per = state.qty > 1 ? ' pro Stück' : '';
      if (diff) diff.textContent = sign + money(delta) + per;
      if (total) total.textContent = 'Neuer Preis: ' + money(target.price) + ' (statt ' + money(state.from.price) + ')';
      // Kurzfassung fuer das Handy: muss in eine Zeile neben den Aufpreis passen.
      if (short) short.textContent = 'neu ' + money(target.price);
    }

    function renderFrame() {
      var target = state.frame;
      var fmt = card('frame', '[data-or-up-format]');
      if (fmt) fmt.textContent = target ? '· ' + target.format : '';
      setPrices('frame', target);
      setPhoto('frame', target);

      var visual = card('frame', '[data-or-up-visual]');
      if (visual && target) {
        var key = frameColorKey(target);
        var isWhite = key.indexOf('WEI') === 0 || key === 'WHITE';
        visual.style.setProperty('--or-up-frame', isWhite ? '#f6f6f4' : '#141414');
        visual.style.setProperty('--or-up-frame-edge', isWhite ? '#c8c8c4' : '#141414');
      }

      if (ui.colors) {
        list(ui.colors.querySelectorAll('[data-or-up-color]')).forEach(function (btn) {
          var on = target && String(btn.dataset.orUpColor) === String(target.id);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
    }

    function buildColors() {
      if (!ui.colors) return;
      ui.colors.innerHTML = '';
      if (state.frames.length < 2) {
        ui.colors.hidden = true;
        return;
      }
      ui.colors.hidden = false;
      state.frames.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'or-up__color';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.dataset.orUpColor = String(v.id);
        var key = frameColorKey(v);
        var isWhite = key.indexOf('WEI') === 0 || key === 'WHITE';
        btn.innerHTML =
          '<span class="or-up__swatch" style="background:' +
          (isWhite ? '#f6f6f4' : '#141414') +
          '"></span><span>' +
          frameColor(v).replace(/[<>&]/g, '') +
          '</span>';
        btn.addEventListener('click', function () {
          state.frame = v;
          renderFrame();
        });
        ui.colors.appendChild(btn);
      });
    }

    function render() {
      var from = state.from;
      if (ui.current) ui.current.textContent = from.format + ' · ' + from.material + ' · ' + money(from.price);

      // Leinwand
      if (ui.cards.canvas) {
        ui.cards.canvas.hidden = !state.canvas;
        if (state.canvas) {
          var fmt = card('canvas', '[data-or-up-format]');
          if (fmt) fmt.textContent = '· ' + state.canvas.format;
          setPrices('canvas', state.canvas);
          setPhoto('canvas', state.canvas);
        }
      }

      // Rahmen
      if (ui.cards.frame) {
        ui.cards.frame.hidden = !state.frame;
        if (state.frame) {
          buildColors();
          renderFrame();
        }
      }

      if (ui.error) ui.error.hidden = true;
      root.classList.remove('or-up--busy');
    }

    function open(from, qty) {
      state.from = from;
      state.qty = qty;
      state.canvas = findCanvas(from);
      state.frames = findFrames(from);
      // Schwarz zuerst, wenn vorhanden.
      state.frames.sort(function (a, b) {
        var ka = frameColorKey(a).indexOf('SCHWARZ') === 0 ? 0 : 1;
        var kb = frameColorKey(b).indexOf('SCHWARZ') === 0 ? 0 : 1;
        return ka - kb;
      });
      state.frame = state.frames[0] || null;

      if (!state.canvas && !state.frame) return false;

      render();
      document.documentElement.classList.add('or-up-open');
      dialog.showModal();
      var focusTarget = card('canvas', '[data-or-up-choose]') || card('frame', '[data-or-up-choose]');
      if (focusTarget && !ui.cards.canvas.hidden) focusTarget.focus();
      return true;
    }

    function close() {
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('or-up-open');
    }

    function choose(kind) {
      if (state.busy) return;
      var target = kind === 'canvas' ? state.canvas : state.frame;
      if (!target || !state.from) return;

      state.busy = true;
      root.classList.add('or-up--busy');
      if (ui.error) ui.error.hidden = true;

      swapInCart(state.from.id, target.id, state.qty)
        .then(function (cart) {
          announceCart(cart);
          close();
          openCartDrawer();
        })
        .catch(function (error) {
          if (window.console && window.console.error) window.console.error('[or-upsell-modal]', error);
          if (ui.error) ui.error.hidden = false;
        })
        .then(function () {
          state.busy = false;
          root.classList.remove('or-up--busy');
        });
    }

    function decline() {
      close();
      openCartDrawer();
    }

    list(root.querySelectorAll('[data-or-up-choose]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        choose(btn.dataset.orUpChoose);
      });
    });
    if (ui.decline) ui.decline.addEventListener('click', decline);
    if (ui.close) ui.close.addEventListener('click', decline);

    // Klick auf den dunklen Hintergrund = "Nein danke".
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) decline();
    });
    // Escape: der Browser schliesst den Dialog selbst, wir raeumen nur auf.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      decline();
    });

    /* ---------- Ausloeser ---------- */

    document.addEventListener('cart:update', function (event) {
      var detail = event.detail;
      if (!detail || !detail.data) return;
      if (detail.data.source !== 'product-form-component') return;
      if (detail.data.didError) return;

      var target = event.target;
      if (target && target.closest && target.closest('.quick-add-modal, quick-add-dialog, product-card')) return;

      var productId = target && target.dataset ? target.dataset.productId : null;
      if (productId && String(productId) !== String(root.dataset.productId)) return;

      var variantId = String(detail.sourceId || '');
      var from = byId[variantId];
      if (!from && target && target.querySelector) {
        var input = target.querySelector('input[name="id"]');
        if (input) from = byId[String(input.value)];
      }
      if (!from) return;

      var qty = Number(detail.data.itemCount) || 1;

      if (isPoster(from)) {
        if (open(from, qty)) return;
      }

      // Kein Upgrade moeglich (z. B. Leinwand oder Rahmen wurde direkt gewaehlt):
      // dann wenigstens den Warenkorb zeigen, damit sichtbar etwas passiert.
      openCartDrawer();
    });
  }

  function boot() {
    list(document.querySelectorAll('[data-or-upsell]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
